import React from 'react';
import { FaCopyright } from 'react-icons/fa';

function Footer() {
  return (
    <div className="Footer">
        <div className="copyright">
            <FaCopyright/>
            <p>  2024-presents Usama ALi All Rights Reserved </p>
        </div>
    </div>
  )
}

export default Footer;